// Constants
import { Endpoints } from "~constants/endpoints"

// Utils
import { Api } from "~utils/api"

// Shapes
import {
  TicketShape,
  TicketStatus,
  TicketListResponse,
  TicketMessageListResponse,
  CreateTicketPayload,
  AddMessagePayload,
  TicketMessageShape,
} from "~shapes/support-ticket"

const buildQuery = (params: Record<string, any>): string =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${v}`)
    .join("&")

const SupportTicketService = {
  getTickets: async (params?: {
    user_id?: string
    status?: string
    category?: string
    page?: number
    page_size?: number
    order_by?: string
    order_dir?: "asc" | "desc"
  }): Promise<TicketListResponse> => {
    const query = buildQuery(params ?? {})
    const url = query
      ? `${Endpoints.SUPPORT_TICKETS.URL}?${query}`
      : Endpoints.SUPPORT_TICKETS.URL
    const { data } = await Api.get(url, {
      headers: { "Cache-Control": "no-cache" },
    })
    return data
  },

  getTicket: async (id: string): Promise<TicketShape> => {
    const { data } = await Api.get(`${Endpoints.SUPPORT_TICKETS.URL}/${id}`, {
      headers: { "Cache-Control": "no-cache" },
    })
    return data
  },

  createTicket: async (payload: CreateTicketPayload): Promise<TicketShape> => {
    const { data } = await Api.post(Endpoints.SUPPORT_TICKETS.URL, payload)
    return data
  },

  updateTicketStatus: async (
    id: string,
    status: TicketStatus,
  ): Promise<TicketShape> => {
    const { data } = await Api.patch(
      `${Endpoints.SUPPORT_TICKETS.URL}/${id}/status`,
      { status },
    )
    return data
  },

  getMessages: async (
    ticketId: string,
    params?: { page?: number; page_size?: number },
  ): Promise<TicketMessageListResponse> => {
    const query = buildQuery(params ?? {})
    const url = query
      ? `${Endpoints.SUPPORT_TICKETS.URL}/${ticketId}/messages?${query}`
      : `${Endpoints.SUPPORT_TICKETS.URL}/${ticketId}/messages`
    const { data } = await Api.get(url, {
      headers: { "Cache-Control": "no-cache" },
    })
    return data
  },

  addMessage: async (
    ticketId: string,
    payload: AddMessagePayload,
  ): Promise<TicketMessageShape> => {
    const { data } = await Api.post(
      `${Endpoints.SUPPORT_TICKETS.URL}/${ticketId}/messages`,
      payload,
    )
    return data
  },

  markTicketAsRead: async (ticketId: string): Promise<void> => {
    await Api.post(`${Endpoints.SUPPORT_TICKETS.URL}/${ticketId}/read`)
  },
}

export default SupportTicketService
